import { selectProcedureTypeById, selectProcedureTypeFieldsById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { procedureTypeFieldsRevisionSettingsDetailViewStaticData } from "src/views/ProcedureTypeFieldsRevisionSettingsDetailView/constants"
import { ProcedureTypeFieldsRevisionSettingsDetailView } from "src/views/ProcedureTypeFieldsRevisionSettingsDetailView/ProcedureTypeFieldsRevisionSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/revisions/$procedureTypeFieldsId",
)({
	component: ProcedureTypeFieldsRevisionSettingsDetailView,
	staticData: procedureTypeFieldsRevisionSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const procedureType = selectProcedureTypeById(params.procedureTypeId)(appStore.getState())
		const procedureTypeFields = selectProcedureTypeFieldsById(params.procedureTypeFieldsId)(appStore.getState())

		if (!procedureType || !procedureTypeFields || procedureTypeFields.procedure_type !== procedureType.uuid) {
			throw notFound()
		}
	},
})
